import React from 'react';

import AddLocationLinkForm
  from 'components/dashboard/location-links-content/AddLocationLinkForm';
import LocationLinksList
  from 'components/dashboard/location-links-content/LocationLinksList';

import './LocationLinksPageContent.css';

function LocationLinksPageContent() {
  return (
    <div className="location-links-page-content__component">
      <AddLocationLinkForm />
      <LocationLinksList />
    </div>
  );
}

export default LocationLinksPageContent;
